var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-icon',{staticClass:"back-arrow h3 mb-4",attrs:{"icon":"arrow-left-square-fill","variant":"button"},on:{"click":function($event){return _vm.$router.go(-1)}}})}
var staticRenderFns = []

export { render, staticRenderFns }